import {combineReducers} from 'redux'

import Cart from './Cart'

// const rootReducer = combineReducers({Cart});
const rootReducer = Cart;

export default rootReducer;
